import { useQuery, queryOptions } from '@tanstack/react-query';
import { getMedicalNoteDetailsById, getMedicalNoteReview, MedicalNoteType } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';


export const useMedicalNoteDetailsByIdQuery = (noteId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'medicalNote', noteId, 'details' ],
    queryFn: async () => {
      const response = await getMedicalNoteDetailsById(noteId);

      return response.data;
    },
    ...opts
  });
};


export const medicalNoteReviewByIdQuery = <TMedicalNoteType extends MedicalNoteType = MedicalNoteType>(noteId: string) => queryOptions({
  queryKey: [ 'medicalNote', noteId, 'review' ],
  queryFn: async () => {
    const response = await getMedicalNoteReview<TMedicalNoteType>(noteId);

    return response.data;
  },
});
